<template>
  <b-modal
    ref="modalAjuda"
    ok-only
    ok-title="Fechar"
    ok-variant="outline-secondary"
    size="lg"
    scrollable
  >
    <b-img
      :src="certificadoHelpImage"
      fluid
      alt="ajuda"
    />
    <template #modal-footer="{ ok }">
      <div class="w-100 d-flex justify-content-between align-items-center">
        <div
          style="font-size:14.5px"
          class="btn btn-outline-primary"
        >
          <font-awesome-icon
            :icon="faDownload"
            class="mr-2"
          />
          <span>
            <a
              :href="url"
              :download="url"
              target="_blank"
              @click.stop
            >
              Fazer download
            </a>
          </span>
        </div>

        <b-button
          variant="outline-secondary"
          @click="ok()"
        >
          Fechar
        </b-button>

      </div>
    </template>
  </b-modal>
</template>

<script>
import { BImg, BButton } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import imgCertificado from '@/assets/images/help-files/CertificadoHelp.png'

export default {
  name: 'CertificadoAjuda',
  components: {
    BImg,
    BButton,
    FontAwesomeIcon,
  },
  data() {
    return {
      certificadoHelpImage: imgCertificado,
      faDownload,
      url: imgCertificado,
    }
  },
  methods: {
    show() {
      this.$refs.modalAjuda.show()
    },
    hide() {
      this.$refs.modalAjuda.hide()
    },
  },
}
</script>
